var getOS = function getOS(agent) {
  var _a;
  var userAgent = (_a = agent === null || agent === void 0 ? void 0 : agent.toLocaleLowerCase()) !== null && _a !== void 0 ? _a : navigator.userAgent.toLocaleLowerCase();
  if (!userAgent) {
    return 'Unknown OS';
  }
  switch (true) {
    case userAgent.indexOf('mac') > -1:
      return 'MacOS';
    case userAgent.indexOf('win') > -1:
      return 'Windows';
    case userAgent.indexOf('linux') > -1:
      return 'Linux';
    default:
      return 'Unknown OS';
  }
};

export { getOS as default };
//# sourceMappingURL=index.js.map
